import { render, staticRenderFns } from "./predicate.vue?vue&type=template&id=287bbc36&"
import script from "./predicate.vue?vue&type=script&lang=js&"
export * from "./predicate.vue?vue&type=script&lang=js&"
import style0 from "./predicate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports